import React from "react";
import { NavLink } from "react-router-dom";
import rightArrow from "../../../assets/images/right-arrow.svg";

const Spondyloarthritis = () => {
  return (
    <section className="py-[50px]">
      <div className="container">
        <div className="spondyloarthritis flex flex-col gap-[15px] rounded-[15px] md:p-[35px] p-[20px] ">
          <h1 className="text-[40px] text-white font-[700] max-w-[1000px] w-full ">
            Suffering from Chronic Back Pain? Assess your risk of having Axial
            Spondyloarthritis
          </h1>
          <p className="text-white max-w-[800px] w-full font-[400] ">
            Take this quick 3-minute A-Tool© survey to understand your risk of
            axial spondyloarthritis if you have had back, hip, or buttock pain
            for more than three months that started before age 45 years.
          </p>
          <NavLink to="/survey" className="pain_survey_btn mt-[15px]">
            Take A-Tool&copy; Back Pain survey
            <div className="arrow_icon flex justify-center items-center ">
              <img src={rightArrow} className="w-[30px]" alt="" />
            </div>
          </NavLink>
        </div>
      </div>
    </section>
  );
};

export default Spondyloarthritis;
